/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const DrawerWrapper = styled.div({
  marginRight: `${gridSize()}px`,
  marginBottom: `${gridSize()}px`,
});

export const BitbucketLogoWrapper = styled.div({
  paddingLeft: `${gridSize()}px`,
  paddingTop: `${gridSize() / 2}px`,
});

export const HeaderNameWrapper = styled.div({
  fontWeight: token('font.weight.semibold'),
});
